<div class="page-detail-wrap vetro-master-bg">
    <h5>{{"Master.certificateType" | translate}}</h5>
</div>
<div class="vetro-bg">
    <div class="p-field form-group">
        <div class="row">
            <div class="col-md-1">
                <label for="name" class="col-form-label">Name</label>
            </div>
            <div class="col-md-3 mb-4">
                <input type="text" pInputText id="name" [(ngModel)]="model.name" required />
            </div>
        </div>
        <div class="row">
            <div class="col-md-1">
                <label for="name" class="col-form-label">Sort Id</label>
            </div>
            <div class="col-md-3 mb-4">
                <input type="text" pInputText id="name" [(ngModel)]="model.sortOrder" required />
            </div>
        </div>
        <div class="row">
            <div class="col-md-1">
                <label for="standard" class="col-form-label">Standard</label>
            </div>
            <div class="col-md-3">
                <p-listbox [options]="standardList" [(ngModel)]="model.standard" optionLabel="name" optionValue="id"
                    [style]="{'width':'15rem'}" [multiple]="true" [checkbox]="true" [filter]="true"
                    [listStyle]="{'max-height':'250px'}" [style]="{'width':'15rem'}"></p-listbox>
            </div>
            <div class="col-md-3">
                <span class="tag" *ngFor="let c of model.standard" style="margin-right: 10px">
                    {{selectedStandards(c)}}
                    <a class="pi pi-times-circle" (click)="delete(c,model)"></a>
                </span>
            </div>
        </div>
    </div>
    <div class="grid grid-nogutter d-flex justify-content-end">
        <button pButton pRipple label="{{'commonbtn.cancel'|translate}}" icon="pi pi-times" class="btn-cancle"
            (click)="cancel()"></button>
        &nbsp;
        <button pButton pRipple label="{{'commonbtn.save'|translate}}" icon="pi pi-check" styleClass="btn-save"
            (click)="save(model)"></button>
    </div>
</div>